import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import Header from "@/core/components/Header";
import Footer from "@/core/components/Footer";
import { UIProvider } from "@/core/components/context/UIContext";
import { CartProvider } from "@/core/components/Cart/CartContext";
import CartDrawer from "@/core/components/Cart/CartDrawer"; // Add this import
import ScrollToTop from "@/core/utils/ScrollToTop";
import routes from "./routes";

// Optimized loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-cannabis-green-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

// Router component that uses the routes
const AppRoutes = () => {
  const element = useRoutes(routes);
  return element;
};

function App() {
  return (
    <UIProvider>
      <CartProvider>
        <div className="min-h-screen flex flex-col">
          <ScrollToTop />
          <Header />
          <main className="flex-grow">
            <Suspense fallback={<PageLoader />}>
              <AppRoutes />
            </Suspense>
          </main>
          <Footer />
          <CartDrawer /> {/* Add the cart drawer here */}
        </div>
      </CartProvider>
    </UIProvider>
  );
}

export default App;
